import { defineMessages } from "react-intl";

const messages = defineMessages({
    messageCenter: {
        id: "Viestikeskus",
        defaultMessage: 'Viestikeskus'
    },
    title: {
        id: "Viestit",
        defaultMessage: 'Viestit'
    },
    noMessagesPrefix: {
        id: "Ei uusia viestejä. Haluatko lähettää meille viestin? Valitse etusivulta lasku, johon asiasi liittyy. Avaa laskun tiedot ja valitse laskusivulta",
        defaultMessage: 'Ei uusia viestejä. Haluatko lähettää meille viestin? Valitse etusivulta lasku, johon asiasi liittyy. Avaa laskun tiedot ja valitse laskusivulta'
    },
    noMessagesSuffix: {
        id: "Jos sinulla ei ole avoimia tai maksettuja laskuja, voit asioida kanssamme chatissa tai puhelimitse.",
        defaultMessage: 'Jos sinulla ei ole avoimia tai maksettuja laskuja, voit asioida kanssamme chatissa tai puhelimitse.'
    },
    noMessagesSuffixWithoutChat: {
        id: "Jos sinulla ei ole avoimia tai maksettuja laskuja, voit asioida kanssamme puhelimitse.",
        defaultMessage: 'Jos sinulla ei ole avoimia tai maksettuja laskuja, voit asioida kanssamme puhelimitse.'
    },
    authError: {
        id: "Tunnistautuminen epäonnistui. Ole hyvä ja yritä uudelleen.",
        defaultMessage: "Tunnistautuminen epäonnistui. Ole hyvä ja yritä uudelleen."
    },
    authErrorShort: {
        id: "Tunnistautuminen epäonnistui",
        defaultMessage: "Tunnistautuminen epäonnistui"
    },
    authRequired: {
        id: "Sinun täytyy tunnistautua ennen kuin voit käyttää MyRopoa.",
        defaultMessage: "Sinun täytyy tunnistautua ennen kuin voit käyttää MyRopoa."
    },
    disabledInEnvironment: {
        id: "Viestikeskus ei ole käytössä tässä ympäristössä.",
        defaultMessage: "Viestikeskus ei ole käytössä tässä ympäristössä."
    },
    errorOccurredTryAgain: {
        id: "Tapahtui virhe. Ole hyvä ja yritä uudelleen.",
        defaultMessage: "Tapahtui virhe. Ole hyvä ja yritä uudelleen."
    },
    underMaintenance: {
        id: "Pahoittelemme, viestikeskus on tilapäisesti poissa käytöstä huollon vuoksi. Yritäthän myöhemmin uudelleen.",
        defaultMessage: "Pahoittelemme, viestikeskus on tilapäisesti poissa käytöstä huollon vuoksi. Yritäthän myöhemmin uudelleen."
    },
    goBack: {
        id: "Palaa takaisin",
        defaultMessage: "Palaa takaisin"
    },
    createNewMessage: {
        id: "Aloita uusi viestiketju",
        defaultMessage: "Aloita uusi viestiketju"
    },
    sortDropdownToggle: {
        id: "Järjestä",
        defaultMessage: "Järjestä"
    },
    sortNewestFirst: {
        id: "Uusin ensin",
        defaultMessage: "Uusin ensin"
    },
    sortUnread: {
        id: "Lukematon",
        defaultMessage: "Lukematon"
    },
    sortByStatus: {
        id: "Viestin tila",
        defaultMessage: "Viestin tila"
    },
    sortByCreditorName: {
        id: "Laskuttajan nimi",
        defaultMessage: "Laskuttajan nimi"
    },
    messageList: {
        id: "Viestilista",
        defaultMessage: "Viestilista"
    }
});

export default messages;
